module.exports = __webpack_public_path__ + "bg-pcdoc-rm-login1920x1028.ff1040511ff58a2cffa6.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/images/bg-pcdoc-rm-login1920x1028.png
// module id = ../../../../../src/assets/images/bg-pcdoc-rm-login1920x1028.png
// module chunks = main